import React, { useRef, useEffect, useState, useContext } from 'react';
import './index.scss';
import { Helmet } from 'react-helmet';
import _ from 'lodash';
import { getLdJson, setMetaContent } from './ldJson.js';
import {
  LEMONAID_DRUGS,
  COOKIES_ZIPCODE,
  COOKIE_SIX_MONTH_EXPIRY_TIME,
  HOME_CANONICAL,
  PRESCRIPTION_CANONICAL,
  PRESCRIPTION_CANONICAL_ES,
  DEFAULT_ZIPCODE,
  HCP_TYPE,
  DRUG_CLASS_CTA,
  ADS_SUPPRESSED_TYPE,
  SPECIALITY_DRUG
} from '../../constants/defaults.js';
import DrugDosageDescription from '../prescription-2/DrugDosageDescription/index.jsx';
import TieredPricingList from '../prescription-2/TieredPricingList/index.jsx';
import PriceHistory from '../prescription-2/PriceHistory/index';
import { updateDosage, handleZipCode } from '../prescription-2/container.js';
import RelatedArticles from '../common/RelatedArticles/index.jsx';
import { useTranslation } from 'react-i18next';
import MobileTreatment from '../prescription-2/MobileTreatment.js';
import PrescriptionLeftMenu from '../prescription-2/PrescriptionLeftLayout.js';
import loadable from '@loadable/component';
import Zipcode from '../common/zipcode.js';
import DisclaimerData from '../common/Disclaimer/index';
import { useSelector, useDispatch } from 'react-redux';
import { authActions } from '../../reducers/authSlice.js';
import PrescriptionAlertModal from '../prescription-2/PrescriptionAlert/index';
import { getLocationByZipCode } from '../../services/Api/SearchBar/SearchBarService.js';
import AdSlot from '../dfp/AdSlot/index';
import TopLoyaltyPricingBanner from '../prescription-2/TopLoyaltyPricingBanner.js';
import {
  EXCLUDED_SEO_FOR_TIMEOUT,
  GPT_HEAD_DRUG_PAGE,
  GPT_TIMEOUT_HEAD_DRUG_PAGE
} from '../../constants/gptHeadTags/drugPage.js';
import useIsMobile from '../../hooks/useIsMobile.js';
import TieredPricingLoader from '../prescription-2/TieredPricingLoader/index.jsx';
import { defineAdSlot } from '../dfp/index';
import SuppressedNote from '../prescription-2/SuppresseNote/index';
import PriceAlerts from '../prescription-2/DrugDosageDescription/PriceAlerts/index';
import SaveDrug from '../prescription-2/DrugDosageDescription/SaveDrug.js';
import HCPNote from '../prescription-2/HCPNote/index.js';
import PatientCompassAd from '../common/PatientCompassAd/index.js';
import { ADS_PLACEMENT } from '../prescription-2/Advertisting/Constant.js';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import RelatedList, {
  RELATED_ITEM_SLUG_KEY,
  RELATED_ITEM_SLUG_PREFIX
} from '../common/RelatedList/index.js';
import AppPromoV1 from '../common/AppPromoV1/index.js';
import { AuthContext } from '../../Contexts.js';
import LoyaltyDLDBanner from '../prescription-2/LoyaltyDLDBanner/index.js';
import PharmaciesTableLogo from '../prescription-2/PharmaciesTableLogo/index.js';

const { API } = require('./../../config/' + process.env.REACT_APP_ENV);

const SignupModal = loadable(() => import('../common/SignupModal.jsx'));

const CareMarkDrug = loadable(() =>
  import('../prescription-2/CareMarkDrug/index')
);
const Lemonaid = loadable(() => import('../prescription-2/Lemonaid/index'));

const PrescriptionCoupons = props => {
  let drugData;
  if (
    typeof window !== 'undefined' &&
    typeof __INITIAL_DATA__ !== 'undefined'
  ) {
    drugData = window.__INITIAL_DATA__;
  } else {
    drugData = props.staticContext !== 'undefined' && props.staticContext.data;
  }
  const { drugName } = props.match.params;
  const { userPoints, location, zipcodeUpdated } = props;
  const initialIds = {
    brandId: 0,
    dosageId: 0,
    formId: 0,
    quantityId: 0
  };
  const {
    drugStructure,
    drugInformation,
    blogData,
    priceHistory,
    similarDrugData,
    isMobileDevice,
    popularDrugs,
    patientCompassData
  } = drugData;
  const { cmsData, relatedDrugs, replaceableVariables } = drugInformation;
  const { lowestPrice, lowestPricePharmacyName } = drugData.tieredPricingData;
  let GPT_SCRIPT;
  if (API?.ALLOW_TIMEOUT_ON_ADS_FOR_INTELLIMIZE) {
    GPT_SCRIPT = EXCLUDED_SEO_FOR_TIMEOUT.includes(drugName)
      ? GPT_HEAD_DRUG_PAGE
      : GPT_TIMEOUT_HEAD_DRUG_PAGE;
  } else {
    GPT_SCRIPT = GPT_HEAD_DRUG_PAGE;
  }
  const [selectedIds, setSelectedIds] = useState(initialIds);
  const [isMobileViewPort, setIsMobileViewPort] = useState(isMobileDevice);
  let isMobileHook = useIsMobile();
  useEffect(() => {
    setIsMobileViewPort(isMobileHook);
  }, [isMobileHook]);
  const [showTieredPricingLoader, setTieredPricingLoader] = useState(false);
  const [tieredPricingData, setTieredPricingData] = useState(
    drugData?.tieredPricingData
  );
  const zipcodeValue =
    typeof localStorage !== 'undefined' &&
    localStorage.getItem('zipCodeData') &&
    JSON.parse(localStorage.getItem('zipCodeData')).zipCode;
  const [zipCode, setZipCode] = useState(zipcodeValue || '23666');
  const [quantityObj, setQuantity] = useState({});
  const [isProceedClicked, setProceedClicked] = useState(false);
  const [isDefaultPage, setIsDefaultPage] = useState(true);
  const [isOpenSignupModal, setSignupModal] = useState(false);
  const [customQuantity, setCustomQuantity] = useState(
    drugStructure.customQuantity
  );
  const [visibleSection, setVisibleSection] = useState();
  const [isSpecialityDrugNew, setisSpecialityDrugNew] = useState(false);
  const [dataLayerEventObj, setDataLayerEventObj] = useState({});
  const [geniusRxPrice, setGeniusRxPrice] = useState('');
  const [isPricingUpdated, setIsPricingUpdated] = useState(false);
  const [isURLDataLoad, setIsURLDataLoad] = useState(false);
  const [showNDCAlert, setShowNDCAlert] = useState(false);
  const [showPriceModal, setShowPriceModal] = useState(false);
  const couponsPrices = useRef(null);
  const priceHistoryRef = useRef(null);
  const faqs = useRef(null);
  const newsResearch = useRef(null);
  const WhatIs = useRef(null);
  const relatedDrugAndConditions = useRef(null);
  const popularPrescriptions = useRef(null);
  const { t, i18n } = useTranslation();
  let isEs = _.isEqual(i18n.language, 'es');
  const dispatch = useDispatch();
  const isAdsVisible = API.ALLOW_DRUG_PAGE_ADS;
  const userData = useContext(AuthContext)?.userData;
  const userName = userData?.firstName;
  const isLoggedIn = userData?.isLoggedIn;
  const pageFrom = useSelector(state => state.authentication.pageFrom);
  const isDrugPriceLoad = useSelector(
    state => state.authentication.isDrugPriceLoad
  );

  let isSuppressedDrug = false;
  let isHealthCareProviderAcquirable = false;
  let isSpecialityDrug = false;
  let isAdSuppressed = false;
  const checkDrugAttributes = type => {
    if (drugStructure?.drugAttributes?.length > 0) {
      return (
        drugStructure?.drugAttributes?.filter(obj => obj.type === type).length >
        0
      );
    } else {
      return false;
    }
  };

  if (!_.isEmpty(drugStructure.defaultKey))
    isSuppressedDrug = drugStructure.defaultKey.isGlobalSuppressionDrug;
  isHealthCareProviderAcquirable = checkDrugAttributes(HCP_TYPE);
  isSpecialityDrug =
    checkDrugAttributes(SPECIALITY_DRUG) || isSpecialityDrugNew;
  isAdSuppressed = checkDrugAttributes(ADS_SUPPRESSED_TYPE);
  const isNormalDrug =
    !isSpecialityDrug &&
    !isSuppressedDrug &&
    !isAdSuppressed &&
    !isHealthCareProviderAcquirable;

  useEffect(() => {
    if (isLoggedIn && !_.isEmpty(localStorage.getItem('saveDrugGTMData'))) {
      const gtmEventObj = JSON.parse(localStorage.getItem('saveDrugGTMData'));
      _.triggerGTMVirtualPageViewEvent({
        event: 'savedDrugsSeeAllPrices',
        ...gtmEventObj
      });
      localStorage.removeItem('saveDrugGTMData');
    }
    // remove cookies set for SCDTC-11108
    _.eraseCookie('drugData');
    if (isAdsVisible) {
      const { sizeMapping } = window;
      const onSizeMappingLoad = () => {
        // if priceHistory section not there then we are not displaying below ads
        const displayAds =
          isAdsVisible &&
          API.ALLOW_PRICE_HISTORY &&
          !_.isEmpty(priceHistory) &&
          !isSpecialityDrug &&
          (priceHistory.showBrandChart || priceHistory.showGenericChart);
        defineAdSlot(
          'div-gpt-ad-1685465718933-0',
          '/22809915073/SingleCare_Drug-Page/drug-page_in-content-1st',
          sizeMapping.inContent,
          displayAds
        );
        defineAdSlot(
          'div-gpt-ad-1685466074135-0',
          '/22809915073/SingleCare_Drug-Page/Drug-page_left-hand_2nd',
          sizeMapping.leftRight,
          displayAds
        );
        defineAdSlot(
          'div-gpt-ad-1685466503138-0',
          '/22809915073/SingleCare_Drug-Page/Drug-page_right-hand_2nd',
          sizeMapping.leftRight,
          displayAds
        );
        /**
         * if we end up missing all of the Price History, FAQ, Related Drugs,
         * and Popular Prescriptions sections at once, then the bottom (footer) ad will not display
         */
        const displayBottomAds =
          isAdsVisible &&
          (!_.isEmpty(cmsData.faqs) ||
            (isSuppressedDrug
              ? !_.isEmpty(relatedDrugs)
              : !_.isEmpty(cmsData.relatedDrugs)) ||
            !_.isEmpty(blogData) ||
            !_.isEmpty(popularDrugs.drugs) ||
            !_.isEmpty(cmsData.relatedConditions) ||
            !_.isEmpty(cmsData.drugClasses));
        defineAdSlot(
          'div-gpt-ad-1685466647655-0',
          '/22809915073/SingleCare_Drug-Page/Drug-page_bottom',
          sizeMapping.inContent,
          displayBottomAds
        );
      };
      if (typeof sizeMapping !== 'undefined') {
        if (sizeMapping.inContent) {
          onSizeMappingLoad();
        } else {
          const sizeMappingListener = () => {
            if (sizeMapping.inContent) {
              return onSizeMappingLoad();
            }
            return setTimeout(sizeMappingListener, 200);
          };
          sizeMappingListener();
        }
      }
    }
  }, []);

  useEffect(() => {
    if (!_.isEmpty(zipcodeUpdated)) {
      handleZipCodeUpdate(zipcodeUpdated);
    }
  }, [zipcodeUpdated]);

  useEffect(() => {
    if (
      !isSuppressedDrug &&
      isLoggedIn &&
      pageFrom === '/prescription' &&
      !isDrugPriceLoad
    ) {
      //  updateDosageSelection();
      handleZipCodeUpdate(zipCode);
      dispatch(
        authActions.pageAction({
          isDrugPriceLoad: true
        })
      );
    }
  }, [isLoggedIn, isDrugPriceLoad, userPoints]);

  useEffect(() => {
    if (isURLDataLoad && !_.isEmpty(quantityObj)) {
      handleZipCodeUpdate();
    }
  }, [isURLDataLoad]);

  const togglePriceModal = zipcode => {
    setShowPriceModal(!showPriceModal);
    if (zipcode && !_.isEqual(zipcode, zipCode)) {
      handleZipCodeUpdate(zipcode);
    }
  };

  const handleURLZIPCode = URLZipCode => {
    if (URLZipCode.length > 4) {
      const zipCodeData = JSON.parse(localStorage.getItem('zipCodeData'));
      if (!_.isEmpty(zipCodeData)) {
        const { zipCode } = zipCodeData;
        if (!_.isEqual(zipCode, URLZipCode)) {
          getLocationByZipCode(URLZipCode).then(res => {
            const locationSearchResults =
              res.status === 200 ? res : res.response;
            if (
              locationSearchResults &&
              locationSearchResults.status === 200 &&
              locationSearchResults.data !== null
            ) {
              localStorage.setItem(
                'zipCodeData',
                JSON.stringify(locationSearchResults.data)
              );
              _.setCookie(
                COOKIES_ZIPCODE,
                URLZipCode,
                COOKIE_SIX_MONTH_EXPIRY_TIME
              );
              setIsURLDataLoad(true);
            }
          });
        } else {
          setIsURLDataLoad(true);
        }
      }
    } else {
      setIsURLDataLoad(true);
    }
  };

  const getdrugIds = (ndcParam, qty) => {
    let drugIds = {};
    let isNDCfound = false;
    let isQTYfound = false;
    let brandTypes = drugStructure.brandTypes;
    for (let brandIndex = 0; brandIndex < brandTypes.length; brandIndex++) {
      let formTypes = brandTypes[brandIndex].formTypes;
      for (let formIndex = 0; formIndex < formTypes.length; formIndex++) {
        let dosage = formTypes[formIndex].dosage;
        for (let dosageIndex = 0; dosageIndex < dosage.length; dosageIndex++) {
          let quantities = dosage[dosageIndex].quantities;
          let quantityIndex = 0;
          for (
            quantityIndex;
            quantityIndex < quantities.length;
            quantityIndex++
          ) {
            let quantity = quantities[quantityIndex];
            if (quantity.ndc == ndcParam) {
              isNDCfound = true;
              if (quantity.quantity == qty) {
                isQTYfound = true;
                break;
              }
            }
          }
          if (isNDCfound) {
            drugIds = {
              brandId: brandIndex,
              formId: formIndex,
              dosageId: dosageIndex,
              quantityId: isQTYfound ? quantityIndex : 0
            };
            return { isNDCfound, isQTYfound, drugIds };
          }
        }
      }
    }
    return { isNDCfound, isQTYfound, drugIds };
  };

  const parseDeepLinkURL = hastURLString => {
    let paramArray = [];
    let urlHash = hastURLString.split('#')[1];
    if (!_.isEmpty(urlHash) && !_.isUndefined(urlHash)) {
      urlHash = decodeURI(urlHash);
      paramArray = urlHash
        .split('|')
        .map(pairs => pairs.split('='))
        .reduce((acc, [k, v]) => {
          acc[k] = v;
          return acc;
        }, []);
    }
    return paramArray;
  };

  const setNDCData = (ndc, qty, customqty) => {
    if (!_.isEmpty(ndc)) {
      const { isNDCfound, isQTYfound, drugIds } = getdrugIds(ndc, qty);
      if (isNDCfound) {
        if (customqty !== 'true' && !isQTYfound) {
          return false;
        }
        drugStructure.drugIds = drugIds;
        setInitialQuantity();
        customqty === 'true' && !isQTYfound && setCustomQuantity(qty);
        return true;
      }
    }
    return false;
  };

  const setDeepLinkData = () => {
    const hastURLString = window.location.hash;
    if (!_.isEmpty(hastURLString)) {
      const {
        customqty,
        zipcode: URLZipCode,
        qty,
        ndc
      } = parseDeepLinkURL(hastURLString);
      if (!_.isUndefined(ndc)) {
        setNDCData(ndc, qty, customqty)
          ? _.isEmpty(URLZipCode) || _.isUndefined(URLZipCode)
            ? setIsURLDataLoad(true)
            : handleURLZIPCode(URLZipCode)
          : setShowNDCAlert(true);
      }
    }
  };

  const setInitialQuantity = () => {
    const newState = {
      ...selectedIds,
      ...drugStructure.drugIds
    };
    setSelectedIds(newState);
    const { brandId, formId, dosageId, quantityId } = newState;
    const quantityObj =
      drugStructure.brandTypes[brandId].formTypes[formId].dosage[dosageId]
        .quantities[quantityId];
    setQuantity(quantityObj);
  };

  const setInitialDataStructure = () => {
    if (!_.isEmpty(drugStructure.drugIds)) {
      setInitialQuantity();
      setIsDefaultPage(true);
      setDataLayerEventObj({
        memberBalance: userPoints,
        drugName: quantityObj.name,
        seoName: quantityObj.seoName,
        NDC: quantityObj.ndc,
        drugBrand: quantityObj.name,
        drugBrandType: quantityObj?.drugType
          ? quantityObj?.drugType
          : quantityObj.isGeneric
          ? 'Generic'
          : 'Brand',
        drugForm: quantityObj.form,
        drugDosage: quantityObj.dosage,
        drugQuantity: quantityObj.quantity,
        drugQuantityUnit: 'count',
        lowestPrice: lowestPrice,
        lowestPricePharmacyName: lowestPricePharmacyName,
        GPI: quantityObj.gpi
      });
    }
  };

  useEffect(() => {
    setInitialDataStructure();
    setDeepLinkData();
    if (typeof window !== 'undefined' && window.location.hash) {
      const sectionId = window.location.hash.substr(1);
      if (sectionId) {
        const element = document.getElementById(sectionId);
        if (element) element.scrollIntoView();
      }
    }
    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [drugName]);

  useEffect(() => {
    let gtmPricingData = [];
    let currentPrice = '';
    if (
      tieredPricingData.mailOrderPricings &&
      !_.isEmpty(tieredPricingData.mailOrderPricings)
    ) {
      const { loyaltyApplicable, loyaltyPrice, price } =
        tieredPricingData.mailOrderPricings[0].prices;
      currentPrice = isLoggedIn && loyaltyApplicable ? loyaltyPrice : price;
      setGeniusRxPrice(currentPrice);
    }

    if (!_.isEmpty(tieredPricingData.PharmacyPricings)) {
      gtmPricingData = tieredPricingData.PharmacyPricings.map((item, key) => {
        const itemPrice = item.Prices[0];
        return {
          pbm: itemPrice.pBAName,
          pharmacyName: item.Pharmacy.Name,
          chainCode: item.Pharmacy.chainCode,
          pharmacyPosition: key,
          pharmacyDistance: item.Pharmacy.Distance,
          pharmacyPrice: itemPrice.Price,
          network: item.Pharmacy.network,
          pharmacyNetPrice: itemPrice.LoyaltyPrice,
          memberSavings: !_.isEmpty(itemPrice.LoyaltyDiscounts)
            ? itemPrice.LoyaltyDiscounts[0].discountAmount
            : '',
          bonusSavings: itemPrice.LoyaltyBonusSavings
        };
      });
    }
    _.triggerGTMVirtualPageViewEvent({
      event: 'pharmacyPriceListLoad',
      pharmacyList: gtmPricingData,
      geniusRxPrice: currentPrice
    });
  }, [tieredPricingData]);

  const handlepFizer = () => {
    setProceedClicked(true);
  };

  const updateDosageSelection = (type, name) => {
    updateDosage(
      type,
      name,
      selectedIds,
      setSelectedIds,
      drugStructure,
      initialIds,
      zipCode,
      customQuantity,
      setQuantity,
      setTieredPricingData,
      setTieredPricingLoader,
      setIsDefaultPage,
      setCustomQuantity,
      setisSpecialityDrugNew,
      setIsPricingUpdated
    );
  };

  const handleMobilePricing = (type, customQty, selectedIds) => {
    updateDosage(
      type,
      customQty,
      selectedIds,
      setSelectedIds,
      drugStructure,
      initialIds,
      zipCode,
      customQty,
      setQuantity,
      setTieredPricingData,
      setTieredPricingLoader,
      setIsDefaultPage,
      setCustomQuantity,
      setisSpecialityDrugNew,
      setIsPricingUpdated
    );
  };

  const renderGTMRelatedData = () => {
    return (
      <div>
        <input
          id="zipcode"
          name="ZIP code"
          type="hidden"
          defaultValue={zipCode}
        />
        <input
          id="usualandcustomary"
          name="UsualAndCustomary price"
          type="hidden"
          defaultValue={
            replaceableVariables && replaceableVariables.priceUsualAndCustomary
          }
        />
        <input
          id="lowestsc"
          name="Lowest Price"
          type="hidden"
          defaultValue={lowestPrice}
        />
        <input
          id="lowestsc_pharmacy"
          name="Pharmacy name"
          type="hidden"
          defaultValue={lowestPricePharmacyName}
        />
        <input
          id="drugname2"
          name="Drug Name 2"
          type="hidden"
          defaultValue={drugName.toLowerCase()}
        />
        <input
          id="data-type"
          name="isDefaultPage"
          type="hidden"
          defaultValue={isDefaultPage}
        />
      </div>
    );
  };

  const sectionRefs = [
    { section: t('MENU COUPON'), ref: couponsPrices },
    { section: t('MENU PRICE HISTORY'), ref: priceHistoryRef },
    { section: t('MENU FAQS'), ref: faqs },
    { section: 'News & Research', ref: newsResearch },
    { section: 'What is', ref: WhatIs },
    { section: 'Related Drug & Conditions', ref: relatedDrugAndConditions },
    { section: 'Popular Prescriptions', ref: popularPrescriptions }
  ];

  const getSEOPages = () => {
    let seoLinks = [];
    if (
      !isEs &&
      drugInformation &&
      cmsData &&
      cmsData.whatIsIndex &&
      !isSpecialityDrug
    )
      seoLinks.push({
        id: 'what-is',
        displayName: 'What is this drug?',
        link: `/prescription/${drugName.toLowerCase()}/what-is`
      });
    if (
      !isEs &&
      !isSpecialityDrug &&
      drugInformation &&
      cmsData &&
      cmsData.dosageGuideSlug
    )
      seoLinks.push({
        id: 'Dosage',
        displayName: 'Dosage',
        link: `/prescription/${cmsData.dosageGuideSlug}/dosage`
      });
    return seoLinks;
  };

  const getSectionList = () => {
    let sectionList = [];
    if (!_.isEmpty(similarDrugData)) {
      sectionList.push({ id: t('ID DRUGS'), displayName: t('MENU DRUGS') });
      sectionList.push({
        id: t('ID SIMILAR DRUGS'),
        displayName: t('MENU SIMILAR DRUGS')
      });
    }
    if (
      !_.isEmpty(tieredPricingData && tieredPricingData.PharmacyPricings) &&
      isNormalDrug
    )
      sectionList.push({ id: t('ID COUPON'), displayName: t('MENU COUPON') });
    if (
      API.ALLOW_PRICE_HISTORY &&
      isNormalDrug &&
      !_.isEmpty(priceHistory) &&
      (priceHistory.showBrandChart || priceHistory.showGenericChart)
    )
      sectionList.push({
        id: t('ID PRICE HISTORY'),
        displayName: t('MENU PRICE HISTORY')
      });
    // if (!_.isEmpty(cmsData?.faqs) && isNormalDrug)
    //   sectionList.push({ id: t('ID FAQS'), displayName: t('MENU FAQS') });
    if (
      !_.isEmpty(blogData) &&
      !isSpecialityDrug &&
      !_.isEqual(i18n.language, 'es')
    )
      sectionList.push({ id: 'news-research', displayName: 'News & Research' });
    sectionList = [...sectionList, ...getSEOPages()];
    return sectionList;
  };

  const getDimensions = ele => {
    const { height } = ele.getBoundingClientRect();
    const offsetTop = ele.offsetTop;
    const offsetBottom = offsetTop + height;

    return {
      height,
      offsetTop,
      offsetBottom
    };
  };

  const handleScroll = () => {
    const scrollPosition = window.scrollY + 150;

    const selected = sectionRefs.find(({ ref }) => {
      const ele = ref.current;
      if (ele) {
        const { offsetBottom, offsetTop } = getDimensions(ele);
        return scrollPosition > offsetTop && scrollPosition < offsetBottom;
      }
    });
    if (selected) {
      setVisibleSection(selected.section);
    } else if (!selected && visibleSection) {
      setVisibleSection(undefined);
    }
  };

  const useDidMountEffect = (func, deps) => {
    const didMount = useRef(false);

    useEffect(() => {
      if (didMount.current) func();
      else didMount.current = true;
    }, deps);
  };

  useDidMountEffect(() => {
    handleScroll();
  }, [visibleSection]);
  // UI vars
  // let title = isEs
  //   ? `${PRESCRIPTION_TITLE_PART1_ES} ${drugInfo.cmsData.name} ${PRESCRIPTION_TITLE_PART2_ES}`
  //   : drugInfo.cmsData.name + PRESCRIPTION_TITLE;

  const isLemonaidDrug = LEMONAID_DRUGS.includes(drugName.toLowerCase());

  const handleZipCodeUpdate = (zipCode = '') => {
    let qty =
      customQuantity && !_.isEmpty(customQuantity)
        ? customQuantity
        : quantityObj.quantity;
    handleZipCode(
      zipCode,
      qty,
      quantityObj.ndc,
      setTieredPricingLoader,
      setZipCode,
      setTieredPricingData,
      null,
      _.isEmpty(customQuantity) ? false : true,
      quantityObj.displayQuantity,
      setIsPricingUpdated
    );
  };

  let doNotMarket;
  if (!_.isEmpty(drugInformation) && drugInformation?.drug) {
    doNotMarket = drugInformation?.drug.deaClassCode.length > 0;
  }

  let leftMenu = getSectionList();
  let seoPgaes = getSEOPages();
  const getMetadata = () => {
    return (
      <Helmet>
        {drugInformation?.drug && (
          <meta
            property="og:title"
            content={drugInformation && cmsData.ogTitle}
          />
        )}
        <meta
          property="og:description"
          content={drugInformation && cmsData.ogDescription}
        />
        <meta
          property="og:image"
          content={drugInformation && drugInformation.imageUrl}
        />
        <meta
          property="og:url"
          content={`https://www.singlecare.com${location.pathname.toLowerCase()}`}
        />
        <meta property="og:site_name" content="SingleCare" />
        <meta property="og:type" content="website" />
        {setMetaContent(drugInformation)}
        <title>{`${cmsData.name} Coupons | SingleCare`}</title>
        <meta
          name="description"
          content={`Get free ${cmsData.name} coupons - Save up to 80% on ${cmsData.name} at your local pharmacy with SingleCare. Print, email or text your coupon.`}
        />
        {isEs ? (
          <link
            rel="canonical"
            href={
              _.isEmpty(drugInformation && cmsData && cmsData.canonicalUrl)
                ? `${HOME_CANONICAL}${location.pathname.toLowerCase()}`
                : `${PRESCRIPTION_CANONICAL_ES}${cmsData.canonicalUrl}`
            }
          />
        ) : (
          <link
            rel="canonical"
            href={
              _.isEmpty(drugInformation && cmsData && cmsData.canonicalUrl)
                ? `${HOME_CANONICAL}${location.pathname.toLowerCase()}`
                : `${PRESCRIPTION_CANONICAL}${cmsData.canonicalUrl}`
            }
          />
        )}
        {/* <link
          rel="alternate"
          href={`https://www.singlecare.com/prescription/${drugName.toLowerCase()}`}
          hrefLang="en-us"
        />
        <link
          rel="alternate"
          href={`https://www.singlecare.com/es/medicamento/${drugName.toLowerCase()}`}
          hrefLang="es-us"
        /> */}
        <script type="application/ld+json">
          {drugInformation?.drug &&
            getLdJson(
              drugName.toLowerCase(),
              drugInformation,
              drugStructure,
              lowestPrice,
              replaceableVariables
            )}
        </script>
        <meta property="seo_name" content={drugName} />
        <meta property="placement_name" content="drug_page" />
        {isAdsVisible && <script>{GPT_SCRIPT}</script>}
      </Helmet>
    );
  };
  return (
    <main>
      <div className="mainContentWrapperPublic">
        {/* <!-- /22809915073/SingleCare_Drug-Page/Drug-page_top --> */}
        {!isMobileViewPort && (
          <div className="topAdsBanner">
            <AdSlot
              id="div-gpt-ad-1685465601155-0"
              className="top"
              featureDisplayAdsFlag={isAdsVisible}
            />
          </div>
        )}
        <div className="homepage-new">
          <div className="prescription-wrapper">
            {isOpenSignupModal && (
              <div className="mainModal afterSignupmodal">
                <div
                  className="transparentBg"
                  onClick={() => {
                    setSignupModal(false);
                  }}
                ></div>
                <div className="signUpModal">
                  <SignupModal
                    closeSignupModal={() => {
                      setSignupModal(false);
                    }}
                  />
                </div>
              </div>
            )}
            {/* Improve Lighthouse performance with pre-API meaningful paint. */}
            <div className="dataContainer">
              {getMetadata()}
              {renderGTMRelatedData()}
              {showNDCAlert && (
                <PrescriptionAlertModal
                  closeDialogHandler={() => setShowNDCAlert(false)}
                />
              )}
              <div
                id="drug-pricing"
                className="drug-pricing"
                ref={couponsPrices}
              >
                <div className="topDrugMainSection">
                  <div className="newScrollMenu">
                    {!isMobileViewPort && leftMenu.length > 0 && (
                      <PrescriptionLeftMenu
                        sectionList={getSectionList()}
                        visibleSection={visibleSection}
                        drugName={drugName}
                        userPoints={userPoints}
                        pathname={location.pathname}
                      />
                    )}
                  </div>
                  <div>
                    {!_.isEmpty(drugStructure) && (
                      <DrugDosageDescription
                        brandTypes={drugStructure.brandTypes}
                        defaultKeys={drugStructure.defaultKey}
                        defaultStructure={drugStructure?.drug}
                        doNotMarket={doNotMarket}
                        drugDescription={drugInformation}
                        drugIds={selectedIds}
                        drugName={cmsData && cmsData.name}
                        lowestPrice={lowestPrice}
                        updateDosage={updateDosageSelection}
                        handleMobilePricing={handleMobilePricing}
                        customQuantity={customQuantity}
                        drugNdc={tieredPricingData.ndc}
                        zipCode={zipCode}
                        handleZipCodeChange={handleZipCodeUpdate}
                        lowestPriceForAleart={tieredPricingData.lowestPrice}
                        setSelectedIds={setSelectedIds}
                        isSpecialityDrugNew={isSpecialityDrug}
                        dataLayerEventObj={dataLayerEventObj}
                        showTieredPricingLoader={showTieredPricingLoader}
                        isSuppressedDrug={isSuppressedDrug}
                        userName={userName}
                        isAdSuppressed={isAdSuppressed}
                        isHealthCareProviderAcquirable={
                          isHealthCareProviderAcquirable
                        }
                        patientCompassData={patientCompassData}
                        isNormalDrug={isNormalDrug}
                        isFromCouponPage={true}
                      />
                    )}
                  </div>
                </div>

                {(isSuppressedDrug || isSpecialityDrug) &&
                  !_.isEmpty(similarDrugData) && (
                    <CareMarkDrug
                      similarDrugs={similarDrugData}
                      drugName={drugInformation && cmsData && cmsData.name}
                      isMobileDevice={isMobileDevice}
                    />
                  )}

                {isMobileViewPort && (
                  <div className="adsInCenter">
                    <AdSlot
                      id="div-gpt-ad-1685465601155-0"
                      className="middleTop"
                      featureDisplayAdsFlag={isAdsVisible}
                    />
                  </div>
                )}

                <div
                  className={`zipLocation ${
                    isHealthCareProviderAcquirable ? 'padding0' : ''
                  }`}
                >
                  {isMobileDevice && isNormalDrug ? (
                    <div className="topZipcode mobile-only">
                      <Zipcode
                        zipCode={zipCode}
                        handleZipCodeChange={handleZipCodeUpdate}
                      />
                    </div>
                  ) : (
                    ''
                  )}

                  <div className="priceMainContainer">
                    {!_.isEqual(i18n.language, 'es') && isNormalDrug ? (
                      <div className="mobile-only">
                        <div
                          role="dialog"
                          aria-haspopup="dialog"
                          className="priceAlert price-alerts-cta price-alerts-link"
                          onClick={event => {
                            event.preventDefault;
                            togglePriceModal();
                          }}
                          tabIndex={0}
                        >
                          <span className="priceAlertsIcon"></span>
                        </div>
                      </div>
                    ) : (
                      ''
                    )}

                    {showPriceModal && (
                      <PriceAlerts
                        drugNdc={tieredPricingData.ndc}
                        hidepriceModal={togglePriceModal}
                        drugName={quantityObj.name}
                        selectedDosage={_.toLower(quantityObj.dosage)}
                        quantity={
                          !_.isEmpty(customQuantity)
                            ? customQuantity
                            : quantityObj.displayQuantity
                        }
                        form={quantityObj.form}
                        lowestPrice={tieredPricingData.lowestPrice}
                        zipcodeValue={
                          _.isEqual(zipcodeValue, DEFAULT_ZIPCODE)
                            ? ''
                            : zipcodeValue
                        }
                        seoName={quantityObj.seoName}
                        finalQty={
                          !_.isEmpty(customQuantity)
                            ? customQuantity
                            : quantityObj.quantity
                        }
                        isCustomQuantity={
                          !_.isEmpty(customQuantity) ? true : false
                        }
                        userName={userName}
                        showPriceModal={showPriceModal}
                      />
                    )}
                  </div>

                  {!_.isEqual(i18n.language, 'es') && isNormalDrug ? (
                    <SaveDrug
                      drugNDC={tieredPricingData.ndc}
                      quantity={
                        customQuantity && !_.isEmpty(customQuantity)
                          ? customQuantity
                          : quantityObj.quantity
                      }
                      kclass={'mobile-only mobileSaveDrug'}
                      ispricingInProgress={showTieredPricingLoader}
                      isCustomQuantity={!_.isEmpty(customQuantity)}
                    />
                  ) : (
                    ''
                  )}
                </div>

                <div className="mobile-only">
                  {/* <Advertisting
                  seoName={drugName}
                  placementPage={ADS_PLACEMENT.DRUG_PAGE}
                /> */}
                  <PatientCompassAd
                    patientCompassData={patientCompassData}
                    seoName={drugName}
                    placementPage={ADS_PLACEMENT.DRUG_PAGE}
                  />
                </div>
                {!isEs &&
                  !_.isEmpty(tieredPricingData) &&
                  tieredPricingData?.loyaltyMemberBonus !== 0 && (
                    <LoyaltyDLDBanner
                      drugName={cmsData && cmsData.name}
                      isLoggedIn={isLoggedIn}
                      loyaltyMemberBonus={tieredPricingData?.loyaltyMemberBonus}
                    />
                  )}
                {isNormalDrug && <TopLoyaltyPricingBanner />}
                {!isMobileViewPort && isAdSuppressed && (
                  /*<div className="compassAds">
                  <Advertisting
                    seoName={drugName}
                    placementPage={ADS_PLACEMENT.DRUG_PAGE}
                  />
                </div>*/
                  <PatientCompassAd
                    patientCompassData={patientCompassData}
                    seoName={drugName}
                    placementPage={ADS_PLACEMENT.DRUG_PAGE}
                  />
                )}
                <div className="middleListsView">
                  <div className="leftAdsBanner">
                    <AdSlot
                      id="div-gpt-ad-1685465849075-0"
                      featureDisplayAdsFlag={isAdsVisible}
                      className={`${isAdSuppressed && 'mt-32'}`}
                    />
                  </div>
                  {isHealthCareProviderAcquirable && !isSpecialityDrug ? (
                    <HCPNote />
                  ) : (
                    <div className="pricingListGrid">
                      {showTieredPricingLoader ? (
                        <TieredPricingLoader />
                      ) : (
                        <>
                          {isSpecialityDrug || isAdSuppressed ? (
                            <SuppressedNote />
                          ) : (
                            <section id={t('ID COUPON')} className="sectionId">
                              <div className="middleListsViewInner">
                                <div className="listBgContainer">
                                  <TieredPricingList
                                    drugName={
                                      drugInformation && cmsData && cmsData.name
                                    }
                                    tieredPricingData={tieredPricingData}
                                    drugData={quantityObj}
                                    quantity={
                                      !_.isEmpty(customQuantity)
                                        ? customQuantity
                                        : quantityObj.displayQuantity &&
                                          quantityObj.displayQuantity.toString()
                                    }
                                    doNotMarket={doNotMarket}
                                    location={zipCode}
                                    showTopPharmacy={true}
                                    selectedDisplayQuantity={
                                      !_.isEmpty(customQuantity)
                                        ? customQuantity
                                        : quantityObj.displayQuantity &&
                                          quantityObj.displayQuantity.toString()
                                    }
                                    handlepFizer={handlepFizer}
                                    isProceedClicked={isProceedClicked}
                                    isLemonaidDrug={isLemonaidDrug}
                                    userPoints={userPoints.amount}
                                    level={'top'}
                                    isHomeDeliveryAvailable={
                                      tieredPricingData.mailOrderPricings &&
                                      !_.isEmpty(
                                        tieredPricingData.mailOrderPricings
                                      )
                                    }
                                    geniusRxPrice={geniusRxPrice}
                                    isMobileDevice={isMobileDevice}
                                    isPricingUpdated={isPricingUpdated}
                                    setIsPricingUpdated={setIsPricingUpdated}
                                    customQuantity={customQuantity}
                                    drugInformationOverrideSeoName={
                                      drugStructure?.defaultKey
                                        ?.drugInformationOverrideSeoName
                                    }
                                  />

                                  <DisclaimerData />
                                  <AppPromoV1
                                    ctaLinks={DRUG_CLASS_CTA}
                                    classes="purpleBg"
                                  />

                                  {isLemonaidDrug && (
                                    <Lemonaid
                                      drugName={
                                        drugStructure?.drug.name.toLowerCase() ||
                                        drugName.toLowerCase()
                                      }
                                    />
                                  )}
                                </div>
                              </div>
                            </section>
                          )}
                        </>
                      )}
                    </div>
                  )}

                  <div className="rightAdsBanner">
                    <AdSlot
                      id="div-gpt-ad-1685465967121-0"
                      className={`topPostion ${isAdSuppressed && 'mt-32'}`}
                      featureDisplayAdsFlag={isAdsVisible}
                    />
                  </div>
                </div>
                <div className="adsInCenter">
                  <AdSlot
                    id="div-gpt-ad-1685465718933-0"
                    featureDisplayAdsFlag={isAdsVisible}
                    displayAdSlot={false}
                  />
                </div>
              </div>

              <MobileTreatment
                doNotMarket={doNotMarket}
                drugInfo={drugInformation}
                lowestPrice={lowestPrice}
                defaultKeys={drugStructure.defaultKey}
              />
              <div>
                <div className="newScrollMenu">
                  {leftMenu.length > 0 && (
                    <PrescriptionLeftMenu
                      sectionList={getSectionList()}
                      visibleSection={visibleSection}
                      drugName={drugName}
                      userPoints={userPoints}
                      pathname={location.pathname}
                    />
                  )}
                </div>
              </div>
              {API.ALLOW_PRICE_HISTORY &&
                !_.isEmpty(priceHistory) &&
                isNormalDrug && (
                  <div>
                    <section id={t('ID PRICE HISTORY')} ref={priceHistoryRef}>
                      <PriceHistory
                        priceHistory={priceHistory}
                        seoName={drugInformation?.drug?.seoName}
                        name={cmsData?.name}
                      />
                    </section>
                  </div>
                )}
              {/* {!isSuppressedDrug && !isSpecialityDrug && <NoCoupons />} */}
              {cmsData?.description ? (
                <section className="desktop-only">
                  <div className="drugInfoMiddlePage">
                    <h2 className="aboutDrugInfo">
                      {cmsData?.name ? `${t('About')} ${cmsData?.name}` : ''}
                    </h2>
                    {documentToReactComponents(cmsData?.description)}
                  </div>
                </section>
              ) : (
                ''
              )}
              <div className="adsInCenter">
                <AdSlot
                  id="div-gpt-ad-1685465793237-0"
                  featureDisplayAdsFlag={isAdsVisible}
                />
              </div>

              {isNormalDrug && <PharmaciesTableLogo drugName={cmsData.name} />}

              <div
                id="prescription-monograph-data"
                className="prescription-monograph-data"
              >
                <div>
                  <div className="newScrollMenu bottomLeftMenu">
                    {seoPgaes.length > 0 && (
                      <PrescriptionLeftMenu
                        sectionList={seoPgaes}
                        visibleSection={visibleSection}
                        drugName={drugName}
                        userPoints={userPoints}
                        pathname={location.pathname}
                      />
                    )}
                  </div>
                </div>

                <div ref={relatedDrugAndConditions}>
                  {!isSuppressedDrug && (
                    <section id="related-drug">
                      {API.ALLOW_CONTENT_FULL_DATA &&
                      cmsData &&
                      !_.isEmpty(cmsData.relatedDrugs) &&
                      !isSpecialityDrug ? (
                        <RelatedList
                          heading={t('Related drugs')}
                          slugPrefix={
                            RELATED_ITEM_SLUG_PREFIX.PRESCRIPTION_PAGE
                          }
                          relatedData={cmsData.relatedDrugs}
                          slugType={RELATED_ITEM_SLUG_KEY.COUPONS}
                        />
                      ) : (
                        <>
                          <RelatedList
                            heading={t('Related drugs')}
                            slugPrefix={
                              RELATED_ITEM_SLUG_PREFIX.PRESCRIPTION_PAGE
                            }
                            relatedData={drugInformation.relatedDrugs}
                            slugType={RELATED_ITEM_SLUG_KEY.COUPONS}
                          />
                        </>
                      )}
                    </section>
                  )}

                  {cmsData &&
                    !_.isEmpty(cmsData.drugClasses) &&
                    !_.isEqual(i18n.language, 'es') && (
                      <RelatedList
                        heading="Related Drug Classes"
                        slugPrefix={RELATED_ITEM_SLUG_PREFIX.DRUG_CLASSES_PAGE}
                        slugType={RELATED_ITEM_SLUG_KEY.SLUG}
                        isLimited={false}
                        relatedData={
                          drugInformation && cmsData && cmsData.drugClasses
                        }
                        id="related-drug-classes"
                      />
                    )}
                  {cmsData &&
                    !_.isEmpty(cmsData.relatedConditions) &&
                    !_.isEqual(i18n.language, 'es') && (
                      <RelatedList
                        heading="Related Conditions"
                        slugPrefix={RELATED_ITEM_SLUG_PREFIX.CONDITIONS_PAGE}
                        slugType={RELATED_ITEM_SLUG_KEY.SLUG}
                        isLimited={true}
                        relatedData={
                          drugInformation &&
                          cmsData &&
                          cmsData.relatedConditions
                        }
                        id="related-conditions"
                      />
                    )}
                </div>
                <section id="news-research" ref={newsResearch}>
                  {!_.isEmpty(blogData) &&
                    !isSpecialityDrug &&
                    !_.isEqual(i18n.language, 'es') && (
                      <RelatedArticles
                        blogData={blogData}
                        drugName={cmsData.name}
                      />
                    )}
                </section>
                {!_.isEmpty(popularDrugs.drugs) && (
                  <div ref={popularPrescriptions}>
                    <RelatedList
                      heading={t('Popular Prescription')}
                      slugPrefix={RELATED_ITEM_SLUG_PREFIX.PRESCRIPTION_PAGE}
                      relatedData={popularDrugs.drugs}
                      id="popular-prescriptions"
                      slugType={RELATED_ITEM_SLUG_KEY.COUPONS}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="adsInCenter marginBottom-20">
          <AdSlot
            id="div-gpt-ad-1685466647655-0"
            featureDisplayAdsFlag={isAdsVisible}
            displayAdSlot={false}
          />
        </div>
        <div id="bottomStickyAd" className="bottomLastAds">
          <AdSlot
            id="div-gpt-ad-1685723492183-0"
            enableCloseBtn={true}
            innerDivClassName="p-1"
            featureDisplayAdsFlag={isAdsVisible}
          />
        </div>
      </div>
    </main>
  );
};

export default React.memo(PrescriptionCoupons);
